import moment from "moment";
import { useEffect } from "react";
import { Button, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { LinkContainer } from "react-router-bootstrap";
import { useHistory } from "react-router-dom";
import Loader from "../components/Loader";
import Message from "../components/Message";
import { getNursesRequest, getSeniorHomesRequest, removeNurseRequest } from "../redux/actions";
import { getNursesByHNRequest } from "../redux/actions/headNurse";
import { AppState } from "../redux/types";
import { ROLE } from "../utils/constants";
import { localePath } from "../i18n/config";

const Nurses = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const user = useSelector((state: AppState) => state.user);
    const nurses = useSelector((state: any) => state.nurses);
    const nursesForHN = useSelector((state: AppState) => state.headNurse.nurses);

    const { list: listForHN, loading: loadingForHN, error: errorForHN } = nursesForHN;
    const { list, loading, error, message } = nurses;

    useEffect(() => {
        if (user && (user.isAdmin || user.role === "it_support")) {
            dispatch(getNursesRequest());
        } else if (user.role === ROLE.HEAD_NURSE) {
            dispatch(getNursesByHNRequest());
        } else {
            history.push(localePath("kirjaudu"));
        }
        dispatch(getSeniorHomesRequest());
        return () => {};
    }, [dispatch, history, user]);

    const handleDeleteNurse = (id: number) => {
        dispatch(removeNurseRequest(id));
    };

    const data = () => {
        return user.role === ROLE.HEAD_NURSE ? listForHN : list ?? [];
    };

    const isLoading = () => {
        return user.role === ROLE.HEAD_NURSE ? loadingForHN : loading;
    };

    const getError = () => {
        return user.role === ROLE.HEAD_NURSE ? errorForHN : error;
    };

    const showActions = (role: string) => {
        switch (role) {
            case ROLE.NURSE:
                return true;
            case ROLE.HEAD_NURSE:
                return user.role !== ROLE.HEAD_NURSE;
            default:
                return false;
        }
    };
    return (
        <>
            <div className="alert-message">
                {Object.keys(message).length !== 0 && (
                    <Message variant={message?.status === 200 ? "info" : "danger"}>
                        <div className="message-text">{message?.message}</div>
                    </Message>
                )}
            </div>
            <div className="headind-button-div">
                <h1 className="my-3 ml-3 module-title">Hoitaja</h1> {/* Nurse */}
                {(user.isAdmin || user.role === ROLE.HEAD_NURSE) && (
                    <LinkContainer to={`/admin/nurses/add`}>
                        <Button className="add-button">LISÄÄ UUSI SAIRAANHOITAJA</Button>
                        {/* ADD NEW NURSE */}
                    </LinkContainer>
                )}
            </div>
            <div>
                {isLoading() ? (
                    <Loader />
                ) : getError() ? (
                    <div className="error-message">
                        <Message variant="danger">
                            <div className="message-text">{getError().message}</div>
                        </Message>
                    </div>
                ) : [...data()]?.length > 0 ? (
                    <Table striped bordered hover responsive className="users-table font-small">
                        <thead className="user-title">
                            <tr className="user">
                                <th className="text-center">{user.isAdmin ? "Päivitä /Poista" : "Muokkaa/Poista"}</th>
                                <th className="text-center">ID</th>
                                <th className="text-center">ROOLI</th>
                                <th className="text-center">Etunimi</th>
                                <th className="text-center">Sukunimi</th>
                                <th className="text-center">Seniori määrätty</th>
                                <th className="text-center">Sähköposti </th>
                                <th className="text-center">Puhelinnumero</th>
                                <th className="text-center">Päiväys Päivitetty</th>
                                <th className="text-center">Yritys</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data()?.map((item: any) => (
                                <tr key={item.userId} className="text-nowrap">
                                    <td className="text-center">
                                        {showActions(item.role) ? (
                                            <>
                                                <LinkContainer className="action-items" to={`/admin/nurses/${item.userId}`}>
                                                    <Button className="btn-sm">
                                                        <i className={user.isAdmin || user.role === ROLE.HEAD_NURSE ? "fas fa-edit" : "fas fa-eye"} style={{ color: "#fff" }} />
                                                    </Button>
                                                </LinkContainer>
                                                {(user.isAdmin || user.role === ROLE.HEAD_NURSE) && (
                                                    <Button variant="danger" className="btn-sm" onClick={() => handleDeleteNurse(item.userId)}>
                                                        <i className="fas fa-trash" />
                                                    </Button>
                                                )}
                                            </>
                                        ) : (
                                            <span className="text-muted">Read Only</span>
                                        )}
                                    </td>
                                    <td className="text-center">{item.userId}</td>
                                    <td className="text-center">{item.role ? item.role.split("_").join("  ") : "  "}</td>
                                    <td className="text-center">{item.firstName}</td>
                                    <td className="text-center">{item.lastName}</td>
                                    <LinkContainer to={`/admin/nurses/seniors/${item.userId}`} style={{ color: "blue", cursor: "pointer" }}>
                                        <td className="text-center">{item.seniorIds?.length}</td>
                                    </LinkContainer>
                                    <td className="text-center">{item.email}</td>
                                    <td className="text-center">{item.mobileNumber}</td>
                                    <td className="text-center">{moment(item?.updatedAt).format("MM/DD/YYYY")}</td>
                                    <td className="text-center">{item.seniorHomes === null ? "-" : item.seniorHomes?.name}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                ) : (
                    <Message variant="light">No Nurse Available!!</Message>
                )}
            </div>
        </>
    );
};

export default Nurses;
